<template>
  <div class="youtube-callback">
    <div class="callback-container">
      <div v-if="loading" class="loading-state">
        <div class="spinner"></div>
        <h2>Processando autenticação...</h2>
        <p>Aguarde enquanto validamos suas credenciais do YouTube.</p>
      </div>

      <div v-else-if="success" class="success-state">
        <div class="success-icon">✓</div>
        <h2>Autenticação realizada com sucesso!</h2>
        <p>Sua conta do YouTube foi conectada com sucesso.</p>
        <button @click="redirectToApp" class="btn-primary">
          Continuar para o aplicativo
        </button>
      </div>

      <div v-else-if="error" class="error-state">
        <div class="error-icon">✗</div>
        <h2>Erro na autenticação</h2>
        <p>{{ errorMessage }}</p>
        <button @click="retryAuth" class="btn-secondary">
          Tentar novamente
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { youtubeService } from '@/services/WebinarSimulator/youtubeService'

export default {
  name: 'YouTubeCallback',
  data() {
    return {
      loading: true,
      success: false,
      error: false,
      errorMessage: '',
    }
  },
  async mounted() {
    await this.handleCallback()
  },
  methods: {
    async handleCallback() {
      try {
        // Captura o código da URL
        const urlParams = new URLSearchParams(window.location.search)
        const userData = localStorage.getItem('userData')
        const userId = userData ? JSON.parse(userData).id : null
        const code = urlParams.get('code')
        const error = urlParams.get('error')

        // Verifica se houve erro na autorização
        if (error) {
          throw new Error(`Erro na autorização: ${error}`)
        }

        // Verifica se o código foi recebido
        if (!code) {
          throw new Error('Código de autorização não encontrado na URL')
        }

        console.log('Código recebido:', code)

        // Envia o código para o backend
        const response = await youtubeService.handleAuthCallback(code, userId)
        
        console.log('Callback processado:', response)

        // Sucesso
        this.loading = false
        this.success = true

        // Redireciona após 3 segundos
        setTimeout(() => {
          this.redirectToApp()
        }, 3000)

      } catch (error) {
        console.error('Erro no callback:', error)
        this.loading = false
        this.error = true
        this.errorMessage = error.message || 'Erro desconhecido na autenticação'
      }
    },

    redirectToApp() {
      // Redireciona para a página principal ou dashboard
      this.$router.push('/app/webinar-simulator') // Ajuste conforme sua rota
    },

    retryAuth() {
      // Volta para a página de autenticação ou reinicia o processo
      this.$router.push('/app/webinar-simulator') // Ajuste conforme sua rota
    }
  }
}
</script>

<style scoped>
.youtube-callback {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
}

.callback-container {
  background: white;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  padding: 40px;
  text-align: center;
  max-width: 500px;
  width: 100%;
}

.loading-state,
.success-state,
.error-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.success-icon {
  width: 60px;
  height: 60px;
  background: #27ae60;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 30px;
  font-weight: bold;
}

.error-icon {
  width: 60px;
  height: 60px;
  background: #e74c3c;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 30px;
  font-weight: bold;
}

h2 {
  margin: 0;
  color: #2c3e50;
  font-size: 24px;
}

p {
  margin: 0;
  color: #7f8c8d;
  font-size: 16px;
}

.btn-primary,
.btn-secondary {
  padding: 12px 24px;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.btn-primary {
  background: #3498db;
  color: white;
}

.btn-primary:hover {
  background: #2980b9;
}

.btn-secondary {
  background: #95a5a6;
  color: white;
}

.btn-secondary:hover {
  background: #7f8c8d;
}
</style>